import { Navigate, RouteObject } from 'react-router-dom';
import { PUBLIC_PATH } from '../shared/constants/paths.constant';
import { lazyWithRetry } from '../shared/utils/lazy-with-retry';
import { createSuspendedRoute } from '../shared/utils/suspended-route.utils';

const Login = lazyWithRetry(() => import('../pages/public/login/login.page'));
const PinLogin = lazyWithRetry(
  () => import('../pages/public/pin-login/pin-login.page')
);
const ForgotPassword = lazyWithRetry(
  () => import('../pages/public/forgot-password/forgot-password.page')
);
const ResetPassword = lazyWithRetry(
  () => import('../pages/public/reset-password/reset-password.page')
);
const VerifyEmail = lazyWithRetry(
  () => import('../pages/public/verify-email/verify-email.page')
);
const Onboarding = lazyWithRetry(
  () => import('../pages/public/onboarding/onboarding.page')
);
const RegistryPage = lazyWithRetry(
  () => import('../pages/public/registry/registry.page')
);

const VerifyEmailPage = lazyWithRetry(
  () => import('../pages/public/verify-email/verify-email.page')
);

export const publicRoutes: RouteObject[] = [
  {
    path: '',
    element: <Navigate to={PUBLIC_PATH.LOGIN} />,
  },
  {
    path: PUBLIC_PATH.LOGIN,
    element: createSuspendedRoute(<Login />),
  },
  {
    path: PUBLIC_PATH.PIN_LOGIN,
    element: createSuspendedRoute(<PinLogin />),
  },
  {
    path: PUBLIC_PATH.FORGOT_PASSWORD,
    element: createSuspendedRoute(<ForgotPassword />),
  },
  {
    path: PUBLIC_PATH.RESET_PASSWORD,
    element: createSuspendedRoute(<ResetPassword />),
  },
  {
    path: PUBLIC_PATH.VERIFY_EMAIL,
    element: createSuspendedRoute(<VerifyEmail />),
  },
  {
    path: PUBLIC_PATH.ONBOARDING,
    element: createSuspendedRoute(<Onboarding />),
  },
  {
    path: PUBLIC_PATH.REGISTRY,
    element: createSuspendedRoute(<RegistryPage />),
  },
  {
    path: PUBLIC_PATH.VERIFY_EMAIL,
    element: createSuspendedRoute(<VerifyEmailPage />),
  },
];
